/*
 * @Author: llzq
 * @Date: 2021-08-22 13:52:55
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:49:19
 * @Description:  头部注释
 */
import React, { Component, ReactNode } from "react";
import axios from "../lib/api.request";
import {
  CascaderExpandTrigger,
  CascaderOptionType,
  FieldNamesType,
  ShowSearchType,
} from "antd/lib/cascader";
import {Cascader as ACascader} from 'antd'
function getUrlParam() {
  let url = window.location.search
  let objRequest = {}
  if (url.indexOf('?') !== -1) {
      url = url.split('?')[1]
      let strArr = url.split('&')
      for (let i = 0; i < strArr.length; i++) {
          objRequest[strArr[i].split('=')[0]] = decodeURI(strArr[i].split('=')[1])
      }
  }
  return objRequest
}
interface CascaderProps {
  dataApi: string;
  /** 默认的选中项 */
  defaultValue?: string[];
  /** 指定选中项 */
  value?: string[];
  /** 选择完成后的回调 */
  onChange?: (value: string[], selectedOptions?: CascaderOptionType[]) => void;
  /** 选择后展示的渲染函数 */
  displayRender?: (
    label: string[],
    selectedOptions?: CascaderOptionType[]
  ) => React.ReactNode;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 自定义类名 */
  className?: string;
  /** 自定义浮层类名 */
  popupClassName?: string;
  /** 浮层预设位置：`bottomLeft` `bottomRight` `topLeft` `topRight` */
  popupPlacement?: string;
  /** 输入框占位文本 */
  placeholder?: string;
  /** 输入框大小，可选 `large` `default` `small` */
  size?: string;
  /** 禁用 */
  disabled?: boolean;
  /** 是否支持清除 */
  allowClear?: boolean;
  showSearch?: boolean | ShowSearchType;
  notFoundContent?: React.ReactNode;
  loadData?: (selectedOptions?: CascaderOptionType[]) => void;
  /** 次级菜单的展开方式，可选 'click' 和 'hover' */
  expandTrigger?: CascaderExpandTrigger;
  /** 当此项为 true 时，点选每级菜单选项值都会发生变化 */
  changeOnSelect?: boolean;
  /** 浮层可见变化时回调 */
  onPopupVisibleChange?: (popupVisible: boolean) => void;
  prefixCls?: string;
  inputPrefixCls?: string;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
  popupVisible?: boolean;
  /** use this after antd@3.7.0 */
  fieldNames?: FieldNamesType;
  /** typo props name before antd@3.7.0 */
  filedNames?: FieldNamesType;
  suffixIcon?: React.ReactNode;
}
export default class Cascader extends Component<CascaderProps> {
  state = {
    data: [],
  };
  async componentDidMount() {
    let { data } = await this.getCascaderData();
    this.setState({
      data,
    });
  }
  getCascaderData = () => {
    return axios.request({
      url:this.props.dataApi,//"https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/dynamicUI/d",
      method: "get",
      params: {...getUrlParam()},
    });
  };
  render() {
    let props = { ...this.props, options: this.state.data };
    delete props.dataApi
    return this.state.data.length > 0 && <ACascader style={{width:'100%'}} {...props} />;
  }
}
